import { Component, OnInit } from '@angular/core';
import { LmsUserService } from 'lms-api';
import { UntypedFormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginComponent } from '../login/login.component';

@Component({
  selector: 'app-header-loginform',
  templateUrl: './header-loginform.component.html',
  styleUrls: ['./header-loginform.component.scss']
})
export class HeaderLoginformComponent implements OnInit {
  public loginError: string;
  public loginInProgress: boolean = false;

  constructor(public lmsUserService: LmsUserService, public modalService: NgbModal) { }

  ngOnInit() {
    this.lmsUserService.OnUserStateChange.subscribe(user => {
      if(user.LoginError == 'LoginByCookie failed' && !this.modalService.hasOpenModals()) {
        this.ShowLoginModal();
      }
    });
  }

  public ShowLoginModal() {
    this.modalService.open(LoginComponent);
  }

  submitLogin(loginForm: UntypedFormGroup) {
    this.loginInProgress = true;
    this.lmsUserService.Login(loginForm.value.user_email, loginForm.value.user_password).subscribe(user => {
      if (user.IsLoggedIn) {
      } else {
        this.loginError = user.LoginError;
      }
      this.loginInProgress = false;
    });
  }
}
